export const GET_EDOK_FORM_BY_MODULE_REQUEST = 'GET_EDOK_FORM_BY_MODULE_REQUEST';

export const getEdokFormByModuleRequest = ({ module, year, identNumber }) => ({
    type: GET_EDOK_FORM_BY_MODULE_REQUEST,
    payload: { module, year, identNumber }
});
